import { render, staticRenderFns } from "./r-prompt-dialog.vue?vue&type=template&id=06709ce6&scoped=true"
import script from "./r-prompt-dialog.vue?vue&type=script&lang=js"
export * from "./r-prompt-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-prompt-dialog.vue?vue&type=style&index=0&id=06709ce6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06709ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06709ce6')) {
      api.createRecord('06709ce6', component.options)
    } else {
      api.reload('06709ce6', component.options)
    }
    module.hot.accept("./r-prompt-dialog.vue?vue&type=template&id=06709ce6&scoped=true", function () {
      api.rerender('06709ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/prompt/r-prompt-dialog.vue"
export default component.exports